module.exports = __webpack_public_path__ + "static/media/UI_CODE_ONE_Background_User_Horizontal.7fb90b19.jpg";